import React from 'react';
import ReactMarkdown from 'react-markdown';
import type { Message } from '../../stores/useChatStore';
import './MessageBubble.css';

interface Props {
  message: Message;
}

export default function MessageBubble({ message }: Props) {
  const isUser = message.role === 'user';
  return (
    <div className={`bubble-row ${isUser ? 'user' : 'assistant'}`}>
      <div className="bubble-avatar">{isUser ? 'Du' : 'KI'}</div>
      <div className="bubble-body">
        <div className="bubble-content">
          {isUser ? (
            <div className="bubble-text">{message.content}</div>
          ) : (
            <ReactMarkdown>{message.content || (message.pending ? '…' : '')}</ReactMarkdown>
          )}
        </div>
        {!isUser && message.costUsd !== undefined && !message.pending && (
          <div className="bubble-meta">
            ${message.costUsd.toFixed(5)} · {message.inputTokens}↑ {message.outputTokens}↓
          </div>
        )}
      </div>
    </div>
  );
}
